<template>
  <button-dialog-container
    :btn-icon="icon"
    :only-icon="true"
    :size="getSize"
    :no-tool-tip="noToolTip"
    :title-tool-tip="titleToolTip"
    :dialog-viewer.sync="dialog"
    @ok-pushed="createWidget"
    @outside-click="outsideClick"
  >
    <v-container class="pa-0 pt-4">
      <div v-if="!controlWeb">
        <v-text-field
          v-model="textEntered"
          :rules="[rules.filter.regex]"
          :label="label"
          :placeholder="placeholder"
          hide-details
          :autofocus="true"
        />
      </div>
      <div v-else>
        <v-combobox
          v-model="textEntered"
          :items="items"
          :label="label"
          :placeholder="placeholder"
          item-text="name"
          item-value="value"
          hide-details
          clearable
          :autofocus="true"
          hide-selected
          small-chips
        />
        <v-switch
          v-model="isFullscreen"
          dense
          flat
          class="mb-n5"
          :label="getLabel"
        />
      </div>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";

export default {
  components: {
    buttonDialogContainer,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    rules: {
      type: Object,
      required: true,
    },
    toolName: {
      type: String,
      default: "",
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    getSize: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      dblclick: false,
      dialog: false,
      isFullscreen: false,
      name: "",
      textEntered: "",
      select: "",
      items: [],
    };
  },
  computed: {
    controlWeb() {
      if (this.toolName == "web") {
        return true;
      } else {
        return false;
      }
    },
    getLabel() {
      if (this.isFullscreen) {
        return "FullScreen";
      } else {
        return "Static";
      }
    },
    open() {
      return this.$store.state.widget.openEditWeb;
    },
  },
  watch: {
    open: function () {
      if (this.open) {
        this.textEntered = this.currentObject.source;
        this.dialog = true;
        this.dblclick = true;
        this.isFullscreen = this.currentObject.isFullscreen;
        this.$store.dispatch("editClose").widget;
      }
    },
  },
  methods: {
    createWidget() {
      if (this.textEntered.value !== undefined) {
        this.textEntered = this.textEntered.value;
      }
      if (this.textEntered.length > 0) {
        this.dialog = false;

        if (!this.dblclick) {
          if (this.toolName) {
            this.$emit("toolSelectedFromDialog", this.toolName);
          }
          if (this.controlWeb) {
            this.$emit("textEntered", {
              url: this.textEntered,
              isFullscreen: this.isFullscreen,
            });
          } else {
            this.$emit("textEntered", this.textEntered);
          }
        } else if (this.dblclick) {
          if (this.controlWeb) {
            this.$emit("editElement", {
              name: this.name,
              content: {
                url: this.textEntered,
                isFullscreen: this.isFullscreen,
              },
              config: this.currentObject.konvaObjectOption,
            });
          } else {
            this.$emit("editElement", {
              name: this.name,
              content: this.textEntered,
              config: this.currentObject.konvaObjectOption,
            });
          }
          this.dblclick = false;
        }

        this.textEntered = "";
      }
    },
    outsideClick() {
      this.textEntered = "";
    },
  },
};
</script>

<style></style>
